import { ArraySectionsType } from '@pages/WindowsCreateOrEdit/types'

import { WindowConfigContainerType } from '@types'

export const getDefaultValuesWindow = (): ArraySectionsType => ({
  id: null,
  title: '',
  internalId: '',
  filterSection: null,
  filterSectionUuid: null,
  filter: null,
  sections: [],
  vars: [],
  configs: [],
})

export const getEmptySection = () => ({
  id: null,
  title: '',
  uuid: null,
  tabs: [],
})

export const getEmptyTab = () => ({
  id: null,
  object: null,
  entity: null,
  entityType: null,
  conditions: '',
  order: null,
  title: '',
  actions: [],
})

export const getEmptyAction = () => {
  return {
    id: null,
    actionTitle: null,
    events: [],
  }
}

export const getEmptyEvent = () => {
  return {
    id: null,
    event: null,
    value: null,
    valueType: null,
    postVariable: null,
    pathArray: null,
  }
}
